import { SearchTerm } from './SearchTerm';

const AreaReportSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "area.areaName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "location.terminals.site.siteName",
        translationKey: "site"
    },
    {
        heading: "Building",
        accessor: "building",
        searchOnName: "location.terminals.building.buildingName",
        translationKey: "building"
    },
    {
        heading: "Zone",
        accessor: "zone",
        searchOnName: "location.zoneByZoneId.zoneName",
        translationKey: "zone"
    },
    {
        heading: "Floor",
        accessor: "floor",
        searchOnName: "location.terminals.floor.floorName",
        translationKey: "floor"
    }
];

export default AreaReportSearch;
